import { baseApi } from '../apiProvider';
import { RequestFollow } from '../models/request/requestFollow';
import { ResponseFollow } from '../models/response/responseFollow';

const followAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // post follow
    postFollow: builder.mutation<any, string>({
      // id is id of user or id of one follow
      query: (id: string) => ({
        url: `/v0/follows/users/${id}`,
        method: 'POST',
      }),
    }),
    //list follower
    getListFollowers: builder.mutation<ResponseFollow[], RequestFollow>({
      query: (params: RequestFollow) => ({
        url: `/v0/users/followers/${params.id}`,
        method: 'GET',
      }),
    }),
    //list follow
    getListFollow: builder.mutation<ResponseFollow[], RequestFollow>({
      query: (params: RequestFollow) => ({
        url: `/v0/users/follows/${params.id}`,
        method: 'GET',
      }),
    }),
    // un-follow
    unFollow: builder.mutation<any, string>({
      // id is id of user or id of one follow
      query: (id: string) => ({
        url: `/v0/follows/users/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  usePostFollowMutation,
  useGetListFollowMutation,
  useGetListFollowersMutation,
  useUnFollowMutation,
} = followAPI;
